import { useSkaldElements } from '@skaldaura/devkit'
import PagesReader from 'components/pagesReader/pagesReader'
import CounterContext from 'contexts/counter'
import { useContext } from 'react'
import 'react-pdf/dist/esm/Page/AnnotationLayer.css'
import 'react-pdf/dist/esm/Page/TextLayer.css'
import './popupVeille.scss'

type PropsType = {
   onClose: () => void
}

const PopupVeille = ({ onClose }: PropsType) => {
   const [elements] = useSkaldElements('Veille')
   const { counterDefault } = useContext(CounterContext)

   return (
      <>
         {elements.length > 0 && (
            <div id='popupZone'>
               <PagesReader
                  pages={elements.map((element) => element.value)}
                  timer={counterDefault * 10}
                  close={onClose}
               />
            </div>
         )}
      </>
   )
}

export default PopupVeille
